module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA/ElEQVQ4T2NkoBAwUqifgbYGqKefWwFy4c2ZRhG4XIrTBRrp5yYxMDDkgjQyMvyfeH2mcQE2Q7AaoJ5+roaRgaEZWQMjA0PF9ZlGneiGYBigkX42jYGBcSY22/4zMCXdnGkwH81gBFc9/bw/I8P/DXhjhpHJ98YMgy0wNXAXaGaetfj/l3ETAyODKIGofcX0/5/ftVkmJyHhAwUaGeeOMvxnsCIuXTBevTHTUAfNgNMOxGmGqLoxw/QA3ID9598L/GWGRBmxgPM/y0xrfd5XcC/svfT+EwMDAy+xBry9IcASFsb4F27AqlX/mYnVDFIH0owSBqRoxpkOyDEEANx3QREqpZx5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/workOrder/closeIcon.png
// module id = JdW3
// module chunks = 1